<template>
  <div>
    <label :for="id">
      <input type="checkbox" v-bind:value="value" v-on:input="$emit('input', $event.target.checked)" :id="id">
      {{ label }}
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      // Id for do references for label
      id: {
        type: String,
        required: true
      },
      // Text to be shown next to checkbox
      label: {
        type: String,
        required: true
      },
      // Value to bind to through v-model
      value: {
        type: Boolean
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/shared/components/Checkbox.vue